<!-- Boxes Section -->
<div class="section newsletter section-contact-us">
  <div class="box box1">
    <h3>
      <span>College</span>Dreams
    </h3>
    <p style="font-size: 17px;">
      A modern school management software <br> designed to eliminate rigorous work,
      so you <br> can focus on the things that matter
    </p>
  </div>
  <div class="box box2">
    <h3>Office Address</h3>
    <div class="block-23 mb-1">
      <ul>
        <li class="mb-2">
          <span class="fa fa-map-marker fa-2x"></span>
          <span class="text">
            15B, Husseini Sommunu Street Ikorodu, Lagos State
          </span>
        </li>
        <li>
          <span class="fa fa-volume-control-phone fa-2x"></span>
          <span class="text">
              080 222 334 89
            </span>
        </li>
      </ul>
    </div>
  </div>
  <div class="box box3">
    <!--<i class="fas fa-cog fa-3x"></i>-->
    <h3>Newsletter</h3>
    <div id="mc_embed_signup">
      <form novalidate #subscribeForm="ngForm" (ngSubmit)="subscribeProcess()">
        <input type="email" name="email" id="newsletter-form-email"
               placeholder="   Email Address"
               #email="ngModel"
               [(ngModel)]="subscribeMail.email"
               [ngModelOptions]="{standalone: true}"
               class="placeholder hide-on-focus" onfocus="this.placeholder = ''"
               onblur="this.placeholder = ' Email Address '">
        <button type="submit" name="submit" id="newsletter-submit"
                class="email_icon newsletter-submit button-contactForm">
          <i class="fa fa-paper-plane" aria-hidden="true"></i>
          <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
        </button>
      </form>
    </div>
    <div class="follow">
      <h4> Follow Us</h4>
      <a href="#pablo" class="btn btn-link btn-just-icon fb">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a href="#pablo" class="btn btn-link btn-just-icon twit">
        <i class="fab fa-twitter"></i>
      </a>
      <a href="#pablo" class="btn btn-link btn-just-icon ig">
        <i class="fab fa-instagram"></i>
      </a>
    </div>
  </div>
</div>
<!--End Boxes Section -->
<footer class="footer footer-default">
  <div class="container">
    <div class="row">
      <div class="mouse">
        <a (click)="scrollToTop()" class="mouse-icon" *ngIf="pageYoffset > 0">
          <div class="mouse-wheel">
            <span class="fa fa-chevron-up" style="color: #ffffff"></span>
          </div>
        </a>
      </div>
    </div>
    <div class="float-left">
      &copy;{{ year }}, CollegeDreams | All rights reserved
    </div>
  </div>
</footer>
